import { useQuery } from '@hooks/reactQuery';

import { getPortalFilesMilestones } from '@api/portalFiles';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithId } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_FILES_MILESTONES } from '@constants/queryKeys';

interface IUseQueryPortalFilesMilestonesReturned {
	portalFilesMilestones: TNameTitleValueLabel[];
	isLoadingPortalFilesMilestones: boolean;
}

export const useQueryPortalFilesMilestones = (projectId?: string): IUseQueryPortalFilesMilestonesReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [GET_PORTAL_FILES_MILESTONES, { projectId }],
		queryFn: extractQueryParams(getPortalFilesMilestones),
		enabled: [projectId],
		allowedRoles: [EUserRoles.portalProjectAdministrator, EUserRoles.portalProjectMember],
		select: requestTypes => optionsFormattedWithId(requestTypes),
		...refetchOptions,
	});

	return {
		portalFilesMilestones: data || [],
		isLoadingPortalFilesMilestones: isInitialLoading,
	};
};
